module.exports = __webpack_public_path__ + "static/img/sp-first-view.6b18d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sp-first-view.png
// module id = Ao/b
// module chunks = 1